import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Send, Eye, Trash2, Mail, MessageSquare } from 'lucide-react';

const tomK = () => ({
  kanal: 'epost', emne: '', innhold: '',
  segment: 'alle', segment_id: null,
});

const Kommunikasjon = () => {
  const [liste, setListe] = useState(null);
  const [open, setOpen] = useState(false);
  const [skjema, setSkjema] = useState(tomK());
  const [grupper, setGrupper] = useState([]);
  const [forhandsvisning, setForhandsvisning] = useState(null);

  const last = useCallback(() => {
    api.get('/kommunikasjon').then((r) => setListe(r.data));
  }, []);
  useEffect(() => {
    last();
    api.get('/grupper').then((r) => setGrupper(r.data || [])).catch(() => {});
  }, [last]);

  const aapne = () => { setSkjema(tomK()); setOpen(true); };

  const forhandsvis = async () => {
    try {
      const r = await api.post('/kommunikasjon/forhandsvis-mottakere', {
        segment: skjema.segment, segment_id: skjema.segment_id, kanal: skjema.kanal,
      });
      setForhandsvisning(r.data);
    } catch (e) {
      alert('Klarte ikke hente mottakere: ' + (e.response?.data?.error || e.message));
    }
  };

  const lagreOgSend = async (send) => {
    if (skjema.kanal === 'epost' && !skjema.emne.trim()) { alert('Emne kreves for e-post.'); return; }
    if (!skjema.innhold.trim()) { alert('Innhold er påkrevd.'); return; }
    const r = await api.post('/kommunikasjon', skjema);
    if (send) {
      const s = await api.post(`/kommunikasjon/${r.data.id}/send`);
      alert(`Sendt til ${s.data.antall_sendt} mottakere. Feil: ${s.data.antall_feil}`);
    }
    setOpen(false); setForhandsvisning(null); last();
  };

  const send = async (k) => {
    if (!window.confirm(`Send "${k.emne || k.innhold.slice(0, 30)}" via ${k.kanal}?`)) return;
    const r = await api.post(`/kommunikasjon/${k.id}/send`);
    alert(`Sendt til ${r.data.antall_sendt} mottakere. Feil: ${r.data.antall_feil}`);
    last();
  };

  const slett = async (k) => {
    if (!window.confirm('Slett kommunikasjonen?')) return;
    await api.delete(`/kommunikasjon/${k.id}`); last();
  };

  if (!liste) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader
        title="Kommunikasjon"
        subtitle="Send e-post og SMS til medlemmer og givere"
        actions={
          <button className="btn-primary" onClick={aapne}>
            <Plus size={14} /> Ny melding
          </button>
        }
      />
      <Card>
        <table className="fm-table">
          <thead><tr><th>Kanal</th><th>Emne / Innhold</th><th>Segment</th><th>Status</th><th>Sendt</th><th>Feil</th><th>Dato</th><th></th></tr></thead>
          <tbody>
            {liste.map((k) => (
              <tr key={k.id}>
                <td>{k.kanal === 'epost' ? <Mail size={14} /> : <MessageSquare size={14} />} {k.kanal}</td>
                <td><strong>{k.emne}</strong><div className="fm-text-muted" style={{ fontSize: 12 }}>{(k.innhold || '').slice(0, 60)}…</div></td>
                <td>{k.segment}</td>
                <td><span className={`badge ${k.status === 'sendt' ? 'badge-success' : k.status === 'feil' ? 'badge-danger' : 'badge-warning'}`}>{k.status}</span></td>
                <td>{k.antall_sendt}</td>
                <td>{k.antall_feil}</td>
                <td>{k.sendt_tidspunkt ? new Date(k.sendt_tidspunkt).toLocaleString('nb-NO') : ''}</td>
                <td style={{ textAlign: 'right' }}>
                  {k.status !== 'sendt' && <button className="btn-ghost" onClick={() => send(k)}><Send size={14} /></button>}
                  <button className="btn-ghost" onClick={() => slett(k)}><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
            {liste.length === 0 && (
              <tr><td colSpan={8} className="fm-text-muted" style={{ textAlign: 'center', padding: 24 }}>
                Ingen meldinger sendt enda.
              </td></tr>
            )}
          </tbody>
        </table>
      </Card>

      <Modal open={open} onClose={() => { setOpen(false); setForhandsvisning(null); }}
             title="Ny kommunikasjon" width={680}
             footer={
               <>
                 <button className="btn-ghost" onClick={forhandsvis}><Eye size={14} /> Forhåndsvis mottakere</button>
                 <button className="btn-secondary" onClick={() => lagreOgSend(false)}>Lagre som utkast</button>
                 <button className="btn-primary" onClick={() => lagreOgSend(true)}><Send size={14} /> Lagre og send</button>
               </>
             }>
        <div className="fm-grid-2">
          <label>Kanal
            <select value={skjema.kanal} onChange={(e) => setSkjema({ ...skjema, kanal: e.target.value })}>
              <option value="epost">E-post</option>
              <option value="sms">SMS (Twilio)</option>
            </select>
          </label>
          <label>Segment
            <select value={skjema.segment} onChange={(e) => setSkjema({ ...skjema, segment: e.target.value, segment_id: null })}>
              <option value="alle">Alle medlemmer</option>
              <option value="gruppe">Gruppe</option>
              <option value="givere">Alle givere</option>
              <option value="aktive_medlemmer">Aktive medlemmer</option>
            </select>
          </label>
          {skjema.segment === 'gruppe' && (
            <label>Velg gruppe
              <select value={skjema.segment_id || ''} onChange={(e) => setSkjema({ ...skjema, segment_id: Number(e.target.value) })}>
                <option value="">— velg —</option>
                {grupper.map((g) => <option key={g.id} value={g.id}>{g.navn}</option>)}
              </select>
            </label>
          )}
        </div>
        {skjema.kanal === 'epost' && (
          <label style={{ display: 'block', marginTop: 12 }}>Emne *
            <input value={skjema.emne} onChange={(e) => setSkjema({ ...skjema, emne: e.target.value })} />
          </label>
        )}
        <label style={{ display: 'block', marginTop: 12 }}>Innhold *
          <textarea rows={8} value={skjema.innhold} onChange={(e) => setSkjema({ ...skjema, innhold: e.target.value })}
                    placeholder={skjema.kanal === 'sms' ? 'Hold SMS kort (160 tegn)…' : 'Skriv meldingen…'} />
        </label>
        {forhandsvisning && (
          <Card style={{ marginTop: 12 }}>
            <strong>{forhandsvisning.antall} mottakere</strong>
            <div className="fm-text-muted" style={{ fontSize: 12, marginTop: 6 }}>
              {(forhandsvisning.eksempel || []).slice(0, 5).join(', ')}
              {forhandsvisning.antall > 5 ? '…' : ''}
            </div>
          </Card>
        )}
      </Modal>
    </>
  );
};

export default Kommunikasjon;
